import gql from 'graphql-tag'

export const libraryPageQuery = gql`
  query LibraryPage($accountId: Int!, $token: String!, $filter: String!) {
    libraryPage(accountId: $accountId, token: $token, filter: $filter) {
      labels {
        id
        accountId
        barcodeSheetId
        name
        width
        height
        elements
        sheet {
          id
          accountId
          name
          size
          width
          height
          topMargin
          bottomMargin
          leftMargin
          rightMargin
          rows
          columns
          rowGutter
          columnGutter
          unit
        }
        barcodeSettings {
          name
        }
      }
      sheets {
        id
        accountId
        name
        size
        width
        height
        topMargin
        bottomMargin
        leftMargin
        rightMargin
        rows
        columns
        rowGutter
        columnGutter
        unit
        labels(accountId: $accountId) {
          id
          accountId
          barcodeSheetId
          name
          width
          height
          elements
        }
      }
      automated {
        id
        accountId
        barcodeLabelId
        name
        output
        barcodeType
        size
        labelFormat
        digits
        prefix
        startNumber
        startingCode
        dataSource
        entityId
        fieldId
        details
        sheet {
          id
          accountId
          name
          size
          width
          height
          topMargin
          bottomMargin
          leftMargin
          rightMargin
          rows
          columns
          rowGutter
          columnGutter
          unit
        }
        label {
          id
          accountId
          barcodeSheetId
          name
          width
          height
          elements
        }
        lastPrinted
        nextToPrint
        reprintEndNumber
      }
      fieldValue {
        id
        accountId
        barcodeLabelId
        name
        output
        barcodeType
        size
        labelFormat
        startingCode
        dataSource
        entityId
        fieldId
        details
        sheet {
          id
          accountId
          name
          size
          width
          height
          topMargin
          bottomMargin
          leftMargin
          rightMargin
          rows
          columns
          rowGutter
          columnGutter
          unit
        }
        label {
          id
          accountId
          barcodeSheetId
          name
          width
          height
          elements
        }
        fieldName
        entityName
        fields
        entities
      }
    }
  }
`
